import * as React from 'react'
import { SVGIconName } from '../../../svgIcons'

export type SVGIconProps = {
  id: SVGIconName
  size?: number
  className?: string
}

export const SVGIcon = (props: SVGIconProps) => {
  const { className, id, size } = props
  return (
    <svg className={className || ''} width={size || 24} height={size || 24} aria-hidden="true">
      <use xlinkHref={`#${id}`} />
    </svg>
  )
}
